// extracted by mini-css-extract-plugin
module.exports = {"copyLinkButton":"copyLink_copyLinkButton__f1MvF","tooltip":"copyLink_tooltip__Fs4CK"};